import { useState, useRef, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

import { Bell } from 'react-bootstrap-icons';
import { Button } from 'react-bootstrap';

import { useNotifications } from 'hoc/NotificationsContext';

import { useRefreshOnFocus } from 'hooks/useRefreshOnFocus';

import { useLocalStorage } from 'utils/storage';

import { formatDate, fetchLatestNotifications } from 'services/notifications';

import "./styles.css";

const NotificationsBell = () => {
    const ref = useRef(null);
    const navigate = useNavigate();

    const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

    const [latestNotifications, setLatestNotifications] = useLocalStorage('latestNotifications', []);
    const { unreadCount, setUnreadCount } = useNotifications();

    const [expanded, setExpanded] = useState(false);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (ref.current && !ref.current.contains(event.target)) {
                setExpanded(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    // #region Focus
    useRefreshOnFocus(() => {
        fetchLatestNotifications().then((data) => {
            if (data) {
                setLatestNotifications(data.data);
                setUnreadCount(data.unread_count);
            }
        });
    }, []);
    // #endregion

    function expandNotificationsList() {
        fetchLatestNotifications().then((data) => {
            if (data) {
                setLatestNotifications(data.data);
                setUnreadCount(data.unread_count);
            }
        });

        setExpanded(prev => !prev);
    }

    function openNotification(notificationId) {
        setExpanded(prev => !prev);

        navigate(`/notifications/${notificationId}`);
    }

    return (
        <div
            ref={ref}
            className="position-relative d-inline-block ms-3"
            style={{ zIndex: 1050 }}
        >
            {/* Bell Button */}
            <button
                type="button"
                className="btn d-flex align-items-center justify-content-center position-relative notification-bell-btn"
                style={{
                    cursor: "pointer",
                    padding: '6px'
                }}
                onClick={(e) => {
                    e.preventDefault();

                    expandNotificationsList();
                }}
            >
                <Bell className="text-secondary" size={30} />

                {unreadCount > 0 ? (
                    <span
                        className="position-absolute top-0 end-0 badge rounded-pill bg-danger"
                        style={{
                            fontSize: "0.6rem",
                            pointerEvents: "none",
                        }}
                    >
                        {unreadCount > 99 ? '99+' : unreadCount}
                    </span>
                ) : null}

            </button>

            {/* Dropdown */}
            {expanded && (
                <div className="notifications-list context-wrapper border">
                    <div className="px-3 py-2 border-bottom border-2">
                        <span className='fs-4'>Notifications</span>
                    </div>

                    {latestNotifications.length > 0 ? (
                        <>
                            <ul
                                className="list-group list-group-flush context-list-group styled-scroll"
                                style={{
                                    height: "300px",
                                    overflow: "auto"
                                }}
                            >
                                {latestNotifications.map((notification, index) => (
                                    <li
                                        key={index}
                                        
                                        className={`list-group-item w-100 ${!isMobile ? 'list-group-item-action' : ''}`}
                                        style={{ cursor: "pointer" }}
                                        onClick={() => {
                                            openNotification(notification.uid);
                                        }}
                                    >
                                        <div className="d-flex justify-content-between">
                                            <small className="text-muted">{formatDate(notification.created_at)}</small>

                                            {!notification.read ? (<span
                                                className="badge rounded-pill bg-danger d-flex align-items-center justify-content-center"
                                                style={{
                                                    fontSize: "0.5rem",
                                                    pointerEvents: "none",
                                                    lineHeight: "1",
                                                    padding: "0.25em 0.4em",
                                                }}
                                            >
                                                new
                                            </span>) : null}

                                        </div>
                                        {notification.details.title}
                                    </li>
                                ))}
                            </ul>

                            <div className="px-3 py-2 text-center border-top border-2">
                                <Button
                                    variant="link"
                                    className={`nav-btn`}
                                    style={{
                                        fontSize: "1rem",
                                    }}
                                    onClick={() => navigate('/notifications')}
                                >
                                    <small className="text-muted">View all notifications</small>
                                </Button>

                            </div>
                        </>
                    ) : (
                        <div
                            className="d-flex align-items-center justify-content-center"
                            style={{
                                    height: "300px"
                                }}
                            >
                                No notifications
                            </div>
                    )}
                </div>
            )}
        </div>
    );
};

export default NotificationsBell;
